import { ICell } from 'rewire-grid';

type ICellRenderSelector = {
  cell:     ICell;
  selector: (cell: ICell) => any;
};

const CellRendererSelector = (props: ICellRenderSelector) => {
  const { cell } = props;
  const selector = cell.column.typeOptions && cell.column.typeOptions.selector;
  return selector ? selector(cell) : null;
};

export default CellRendererSelector;